<template>

    <w-flex wrap class="text-center basis-zero">
        <br />
        <div class="xs2 pa2">

            <w-card title="Search" title-class="primary-dark1--bg">
                <w-form @submit.prevent="search()">
                    <w-input class="mxa" label="Model Search" v-model="newSearch" name="newSearch"
                        inner-icon-left="wi-search" label-position="inside" outline="outline"></w-input>
                    <w-button bg-color="warning" type="submit">Search</w-button>
                </w-form>
                <w-form @submit.prevent="searchPN()">
                    <w-input class="mt6 mb2" label="Spare Part Search" v-model="SparePartSearch" name="newSearch"
                        inner-icon-left="wi-search" label-position="inside" outline="outline"></w-input>
                    <w-button bg-color="warning" type="submit">Search</w-button>
                </w-form>
                <template #actions>
                    <div class="spacer"></div>
                </template>
            </w-card>

            <div class="pt2">
                <w-card title="Device Details" title-class="primary-dark1--bg">
                    <w-table style="margin: auto;" :headers="lookingat.headers" :items="lookingat.items"
                        :mobile-breakpoint="1280">
                        <template #no-data>👌 There is no data! 👌</template>
                    </w-table>
                </w-card>
            </div>
            <div class="pt2">
                <w-card title="Exploded Views" title-class="primary-dark1--bg">
                    <table style="margin: auto;">
                        <thead class="thead-dark">
                            <!-- <th>Files</th> -->
                        </thead>
                        <tbody>
                            <tr v-for="file in files" :key="file.illustrationImage">
                                <td>
                                    <img class="file" :src="file.illustrationImage" @click="openfile(file)" />
                                    <h1>{{ file.title }}</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </w-card>
            </div>
        </div>

        <!-- <h2>Searching for : {{newSearch||SparePartSearch}}</h2> -->
        <!-- <h1>ID:{{articleNo}}</h1> -->
        <!-- <form @submit.prevent="searchPartNumber()">
        <label>Part Search</label>
        <input v-model="newPartSearch" name="newSearch" />
        <button>Search</button>
      </form>-->

        <div class="xs9 pa2">
            <w-card title="Results" title-class="primary-dark1--bg">
                <w-accordion :items="1" v-model="PartsTable.accordion">
                    <template #item-title>Parts {{ PartsTable.items.length }}</template>

                    <template #item-content>
                        <w-flex justify-center class="pa2">
                            <w-input inner-icon-left="wi-search" label-position="inside" outline="outline"
                                label="Part Search " v-model="PartSearch" />
                            <w-input inner-icon-left="wi-search" label-position="inside" outline="outline"
                                label="Pos No " v-model="PosLookup" />
                            <w-button icon="mdi mdi-filter" text lg class="ml3" bg-color="warning" outline
                                @click="FilterButton()"></w-button>
                        </w-flex>
                        <w-table :headers="PartsTable.headers" :items="PartsTable.items" :mobile-breakpoint="1280"
                            :loading="PartsTable.loading" :sort="PartsTable.sort" :filter="PartsTable.filter"
                            :selectable-rows="PartsTable.selectableRows" @row-select="getPartDetails($event.item)">
                            <template #no-data>👌 There is no data! 👌</template>

                            <template #item-cell="{ item, label, header }">
                                <div v-if="header.label == 'ID'">
                                    <img :src="item.imageThumbnail" />
                                </div>

                                <!-- <div
                    v-if="item.Lieferzeit !='Voraussichtlich lieferbar innerhalb von 1 - 2 Wochen'"
                  >Expected to be available within 1 - 2 weeks</div>
                  <div
                    v-if="item.Lieferzeit =='Voraussichtlich lieferbar innerhalb von 4 - 5 Wochen'"
                  >Expected to be available within 4 - 5 weeks</div>-->

                                <div :style="item.style">{{ label }}</div>
                            </template>
                        </w-table>
                    </template>
                </w-accordion>

                <w-accordion :items="1" v-model="Devices.accordion">
                    <template #item-title>Models {{ Devices.items.length }}</template>

                    <template #item-content>
                        <w-table :headers="Devices.headers" :items="Devices.items" :loading="Devices.loading"
                            :mobile-breakpoint="1280" :selectable-rows="true" :sort="Devices.sort"
                            select-row="select-row" @row-select="selectionInfo = $event">
                            <!-- @row-select="searchDeviceArticle(filterByCodeOrType(Devices.items,$event.item))" -->
                            <!-- @row-select="searchDeviceArticle([$event.item,Devices.items.filter(it=>{if (it.suppliers !== $event.item.suppliers && (it.Type == $event.item.Type.trim() && it.Identnummer == $event.item.Identnummer)) return it})])" -->

                            <template #no-data>👌 There is no data! 👌</template>
                        </w-table>
                    </template>
                </w-accordion>
                <w-button bg-color="warning" @click="getALLParts(selectionInfo.selectedRows)">Search Selected</w-button>
            </w-card>
        </div>
        <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width"
            :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white">
            <template #title>
                <w-icon class="mr2">mdi mdi-tune</w-icon>View File
            </template>
            <!-- {{ fileurl }} -->
            <!-- <object :data="fileurl" frameborder="0" width="100%" height="600px" style="padding: 20px;">
                <iframe height="100%" width="100%" style="border:none;" :src="fileurl"></iframe>
            </object> -->
            <!-- <iframe :src="fileurl" style="width:100%; height:650px;" frameborder="0"></iframe> -->

            <!-- <embed type="application/x-google-chrome-pdf"
                src="chrome-extension://mhjfbmdgcfjbbpaeojofohoefgiehjai/602420b2-c69b-486d-99f9-ece26af579be"
                :original-url="fileurl" javascript="allow"> -->

            <!-- <embed type=" application/pdf" :src="fileurl" background-color="4283586137" javascript="allow" -->
            <!-- full-frame=""> -->
            <VuePdf v-for="page in numOfPages" :key="page" :src="fileurl" :page="page" />
            <template #actions>
                <div class="spacer"></div>
                <w-button bg-color="warning" @click="dialog.show = false">Close</w-button>
            </template>
        </w-dialog>
    </w-flex>
</template>
  
<script>
import { ref } from "vue";
import axios from "axios";
// import json from "../assets/allparts.json";
// import djson from "../assets/allDParts.json";
import router from "../router"
import { usePartStore } from '../store/part'
import { providersToModelList, providersToPartsList, getPartsListFromSupplier, getAswoFileFromUrl } from "./Wrapper.js";
import { VuePdf, createLoadingTask } from 'vue3-pdfjs/esm';
// import { VuePdfPropsType } from 'vue3-pdfjs/components/vue-pdf/vue-pdf-props'; // Prop type definitions can also be imported
// import { PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api';
export default {
    components: {
        VuePdf
    },
    mounted() {

    },

    setup() {
        const dialog = ref({
            show: false,
            fullscreen: true,
            persistent: false,
            persistentNoAnimation: false,
            width: 800,
            height: 800
        });
        const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
        const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect

        const Providers = [ASWOProvider, ConnectProvider]
        const newPartSearch = ref("");
        const newSearch = ref("");
        const SparePartSearch = ref("");
        const PartSearch = ref("");
        const StockCheck = ref("In Stock");
        const DeliveryTime = ref(100);
        const Obsolete = ref(-1);
        const PosLookup = ref("");
        const ArticleSearch = ref("");
        const DeviceArticleSearch = ref("");
        const DeviceFilesSearch = ref("");
        const fileurl = ref("");

        let PartsTable = ref({
            headers: [
                { label: "Supplier", key: "supplierName", align: "center" },
                { label: "ID", key: "id", align: "center" },
                { label: "Brand/Family", key: "brand", align: "center" },
                { label: "P/N", key: "partNumber", align: "center" },
                { label: "Man Code", key: "manufactureCode", align: "center" },
                { label: "Description", key: "description", align: "center" },
                { label: " Price ", key: "fullPrice", align: "center" },
                { label: " Unit Price ", key: "unitPrice ", align: "center" },
                { label: "In Stock", key: "inStock", align: "center" },
                { label: "Special Order", key: "specialOrder", align: "center" },
                { label: "Obsolete", key: "Obsolete", align: "center" },
                { label: "Alternative", key: "Alternative", align: "center" },
                { label: "Pos No", key: "positionNumber", align: "center" }
            ],
            items: [],
            selectableRows: true,
            selectionInfo: {},
            loading: false,
            accordion: [false],
            sort: "+description",
            filter: item =>
                item.description.toUpperCase().includes(
                    PartSearch.value.toUpperCase()
                )
                    &&

                    item.positionNumber ? item.positionNumber.includes(PosLookup.value.toUpperCase()) : false

        });

        let articleNo = ref({});
        let Devices = ref({
            headers: [
                { label: "Supplier", key: `supplierName`, align: "center" },
                { label: "Brand	", key: "brand", align: "center" },
                { label: "Family", key: "type", align: "center" },

                { label: "Model", key: "model", align: "center" },
                { label: "Code", key: "variant", align: "center" },
                { label: "Number Of Parts", key: "totalResults", align: "center" }
            ],
            items: [],
            loading: false,
            accordion: [false],
            sort: "-model"
        });
        let files = ref({});
        let lookingat = ref({
            headers: [
                { label: "Supplier", key: `supplierName`, align: "center" },
                { label: "Brand	", key: "brand", align: "center" },
                { label: "Family", key: "type", align: "center" },

                { label: "Model", key: "model", align: "center" },
                { label: "Code", key: "variant", align: "center" },
                { label: "Number Of Parts", key: "totalResults", align: "center" }
            ],
            items: []
        });
        // const allparts = Object.assign({}, json.Parts, djson.DParts);




        function search() {
            this.articleNo = null;
            Devices.value.items = [];
            files.value = [];
            lookingat.value.items = []
            PartsTable.value.items = [];
            PartsTable.value.accordion = [false];
            Devices.value.accordion = [true];
            SparePartSearch.value = ""
            Devices.value.loading = true;
            if (newSearch.value == "") {
                router.push({ name: 'search' })
                Devices.value.loading = false;
                return
            }
            providersToModelList(newSearch.value).then(models => {
                Devices.value.items = models.flatMap(el => el)
                Devices.value.loading = false;
            })

        }
        function searchPN() {
            Devices.value.items = [];
            lookingat.value.items = [];
            files.value = [];
            Devices.value.accordion = [false];
            PartsTable.value.items = [];
            PartsTable.value.accordion = [true];
            newSearch.value = ""
            PartsTable.value.loading = true;
            if (SparePartSearch.value == "") {
                PartsTable.value.loading = false;
                return
            }
            providersToPartsList(SparePartSearch.value).then(listOfParts => {
                PartsTable.value.items = listOfParts.flatMap(el => el)
                PartsTable.value.loading = false;
            });
        }

        function getALLParts(listOfProducts) {
            PartsTable.value.items = [];
            lookingat.value.items = [];
            PartsTable.value.accordion = [true];
            PartsTable.value.loading = true;
            lookingat.value.items = listOfProducts

            getPartsListFromSupplier(listOfProducts).then(listOfParts => {
                PartsTable.value.items = listOfParts.flatMap(el => [...el.items.flat(1)])
                files.value = listOfParts.flatMap(el => [...el.files.flat(1)])
                // .map(file => {
                //     file.url = usePDF(file.url)
                //     return file
                // })
                PartsTable.value.loading = false

                console.log(PartsTable.value);
                console.log(files.value);
            })

        }

        function searchPartNumber() { }
        function getPartDetails(part) {
            usePartStore().setPart(part)
            router.push({ name: 'Part', params: { id: part.id } })
        }

        function getSeviceNetParts() { }
        function getAltParts() { }
        const numOfPages = ref(0)
        function openfile(file) {

            console.log(file);
            if (file.supplierName == "ASWO") {
                getAswoFileFromUrl(file.url).then(fileData => {
                    const pdfSrc = ref(URL.createObjectURL(fileData))
                    const loadingTask = createLoadingTask(pdfSrc.value)
                    loadingTask.promise.then((pdf) => {
                        numOfPages.value = pdf.numPages
                    })
                    this.fileurl = pdfSrc
                }
                )
            }
            if (file.supplierName == "Connect") {
                const pdfSrc = ref(file.url)
                const loadingTask = createLoadingTask(pdfSrc.value)
                loadingTask.promise.then((pdf) => {
                    numOfPages.value = pdf.numPages
                })
                this.fileurl = pdfSrc;
            }
            this.dialog.show = true;
            // this.fileurl = file;

            console.log(this.fileurl);

            // window.open(file, "_blank");
        }
        return {
            numOfPages,
            supplier: { name: String, code: String },
            getPartDetails,
            getALLParts,
            getSeviceNetParts,
            getAltParts,
            fileurl,
            newSearch,
            newPartSearch,
            search,
            searchPartNumber,
            searchPN,
            // searchArticle,
            SparePartSearch,
            PosLookup,
            PartSearch,
            StockCheck,
            DeliveryTime,
            Obsolete,
            // searchDeviceArticle,
            ArticleSearch,
            DeviceArticleSearch,
            DeviceFilesSearch,
            // searchDeviceFiles,
            // filterByCodeOrType,
            // searchArticleReplacment,
            articleNo,
            Devices,
            files,
            lookingat,
            openfile,
            // FilterButton,
            // allpartsjson: json,
            name: "Search Aswo",
            props: {
                msg: String
            },
            PartsTable,
            dialog,
            getitemcontrols() {
                return `Artikelnummer`;
            }
        };
    }
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w-app .primary--bg {
    background-color: #021d48;
}
div.w-table-wrap{
 
 height: 65vh;

}table.w-table.w-table--mobile{
 
 height: 65vh;

}
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

img {
    height: 50px;
    width: 50px;
}

.file {
    /* /* height: 150px; */
    width: 100%;
}
</style>
